<template>
    <button
        class="simple-btn v-btn"
        :class="[lightTheme ? 'simple-btn-light' : 'simple-btn-dark', staticClass || '']"
        :disabled="disabled"
        @click="$emit('click', $event)"
    >
        <slot />
    </button>
</template>

<script setup>
defineProps({
    lightTheme: Boolean,
    disabled: {
        required: false,
        type: Boolean,
        default: null,
    },
    // fixed [Vue warn]: Property "staticClass" was accessed during render but is not defined on instance.
    // TODO: check if it still necessary
    staticClass: {
        required: false,
        type: String,
        default: null,
    },
});
defineEmits(['click']);
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.simple-btn {
    padding: 0 1.2rem !important;
    height: 2rem !important;

    &-light {
        background-color: $promo-white;
        border: 0.1rem solid $promo-primary-colour;
        color: $promo-primary-colour;
    }

    &-dark {
        background-color: $promo-primary-colour;
        color: $promo-white;
        &:not([disabled='disabled']):hover {
            background-color: $rtls-secondary-button-hover-colour !important;
        }
    }
    &[disabled='disabled'] {
        background-color: $promo-grey-7;
    }
}
</style>
